import React, {Component} from 'react'
import {connect} from 'react-redux'
import api from 'api'
import EmployeesList from 'procedures/EmployeesList'
import {asyncError} from 'store/actions/asyncError'
import withRouterLegacy from 'withRouterLegacy'

class ChooseEmployeeDirect extends Component {
  render() {
    const {startProcedure, token} = this.props
    return (
      <div>
        <div className="l-title-wrap">
          <h1 className="m-title-main">従業員を選択してください</h1>
        </div>
        <div className="l-wrap-xl">
          <EmployeesList handleClick={(employeeId) => startProcedure(employeeId, token, this.props.history)} />
        </div>
      </div>
    )
  }
}

export default withRouterLegacy(
  connect(
    (state) => ({
      token: state.auth.token,
    }),
    (dispatch) => ({
      async startProcedure(employeeId, token, history) {
        try {
          const {
            data: {id},
          } = await api.createWithAuth(token).procedureStatuses.start(employeeId, 'enroll')
          history.push(`/enroll/detail/${id}`)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )(ChooseEmployeeDirect)
)
